import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import { useParams } from 'react-router-dom';
import RequestQuoteFormListTable from './RequestQuoteFormListTable';
import { RequestQuoteForm } from '../../Models/RequestQuoteForm';
import RequestQuoteApi from '../../Api/RequestQuoteApi';

export default function RequestQuoteList() {
  const { id } = useParams();
  const [requestQuoteData, setRequestQuoteData] = useState<RequestQuoteForm[]>(
    []
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getContactForms();
  }, []);

  const getContactForms = () => {
    // if (id) {
    try {
      setIsLoading(true);
      return RequestQuoteApi.getQuotesList()
        .then((res) => {
          setRequestQuoteData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
    // }
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <RequestQuoteFormListTable data={requestQuoteData} />
        </div>
      </div>
    </>
  );
}
